/**
 * QuickLink
 */
import React from 'react';
import { Icon } from '..';
import { Link as LinkBase } from 'ui-component-library/base';
/** Main description for this component. */
var QuickLink = function (_a) {
    var text = _a.text, _b = _a.url, url = _b === void 0 ? '#' : _b, target = _a.target, icon = _a.icon, _c = _a.LinkComponent, LinkComponent = _c === void 0 ? LinkBase : _c;
    var Link = LinkComponent;
    return (React.createElement("li", { className: "ml-6" },
        React.createElement(Link, { to: url, className: "flex items-center text-teal hover:underline", target: target },
            icon && (React.createElement(Icon, { icon: icon, size: 1, className: "mr-1", "aria-hidden": true })),
            text)));
};
export default QuickLink;
